module.exports = __webpack_public_path__ + "img/banner09_01.18936bbc.png";